import { render, staticRenderFns } from "./promotions.vue?vue&type=template&id=3ea525bc"
import script from "./promotions.vue?vue&type=script&lang=js"
export * from "./promotions.vue?vue&type=script&lang=js"
import style0 from "./promotions.vue?vue&type=style&index=0&id=3ea525bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports